import React, { Component } from 'react'
import { Button, Checkbox, Radio, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap'
import * as firebase from 'firebase';
import '../App.css'

export default class AddSinglePage extends Component {
  constructor (props) {
    super(props)

    this.tasksRef = null

    // Start with empty user object
    this.state = {
      newValues: {
        single: true,
        interests: {}
      },
      submitEnabled: false
    }
  }

  refreshSubmitButton () {
    // Check all values in state
    var enabled = (
      this.state.newValues.displayName !== null &&
      this.state.newValues.dateOfBirth !== null &&
      this.state.newValues.gender !== null &&
      Object.keys(this.state.newValues.interests).length > 0
    )

    this.setState({submitEnabled: enabled})
  }

  userPropertyForKey (key, defaultValue = null) {
    if (this.state.newValues.hasOwnProperty(key)) {
      return this.state.newValues[key]
    } else {
      return defaultValue
    }
  }

  getRenderedForm () {
    const displayName = this.userPropertyForKey('displayName', '')
    const dateOfBirth = this.userPropertyForKey('dateOfBirth', '')
    const gender = this.userPropertyForKey('gender', null)
    const interests = this.userPropertyForKey('interests', {})

    return (
      <div>
        <h2>Add Single</h2>
        <form>
          <FieldGroup id='displayName' type='text' label='Display name' value={displayName} onChange={this.displayNameChanged} />
          <FieldGroup id='dateOfBirth' type='date' label='Date of birth' value={dateOfBirth} onChange={this.dateOfBirthChanged} />
          <ControlLabel>Single:</ControlLabel>
          <FormGroup controlId='single'>
            <Radio id='yesSingleRadio' name='single' inline={true} checked={true} disabled>Yes</Radio>
            <Radio id='noSingleRadio' name='single' inline={true} checked={false} disabled>No</Radio>
          </FormGroup>
          <ControlLabel>Gender:</ControlLabel>
          <FormGroup controlId='gender'>
            <Radio id='male' name='gender' inline={true} checked={gender === 'male'} onChange={this.genderChanged}>Male</Radio>
            <Radio id='female' name='gender' inline={true} checked={gender === 'female'} onChange={this.genderChanged}>Female</Radio>
            <Radio id='other' name='gender' inline={true} checked={gender === 'other'} onChange={this.genderChanged}>Other</Radio>
          </FormGroup>
          <ControlLabel>Interested in:</ControlLabel>
          <FormGroup>
            <Checkbox id='male' inline={true} checked={interests.male === true} onChange={this.interestChanged}>Male</Checkbox>
            <Checkbox id='female' inline={true} checked={interests.female === true} onChange={this.interestChanged}>Female</Checkbox>
            <Checkbox id='other' inline={true} checked={interests.other === true} onChange={this.interestChanged}>Other</Checkbox>
          </FormGroup>
          <Button type='submit' disabled={!this.state.submitEnabled} onClick={this.submitButtonClicked}>Add User</Button>
        </form>
      </div>
    )
  }

  render () {
    const form = this.getRenderedForm()

    return (
      <div className='AddSinglePage'>
        {form}
      </div>
    )
  }

  displayNameChanged = (event) => {
    this.updateUserProperty('displayName', event.target.value)
  }

  dateOfBirthChanged = (event) => {
    this.updateUserProperty('dateOfBirth', event.target.value)
  }

  genderChanged = (event) => {
    var gender = event.target.id

    if (this.state.newValues.gender !== gender) {
      this.updateUserProperty('gender', gender)
    }
  }

  interestChanged = (event) => {
    var gender = event.target.id
    var interested = event.target.checked

    var interests = this.state.newValues.interests
    if (interested) {
      interests[gender] = true
    } else {
      delete interests[gender]
    }

    this.updateUserProperty('interests', interests)
  }

  updateUserProperty = (key, value) => {
    // Update the value for the given key in the state
    var obj = this.state.newValues
    obj[key] = value
    this.setState({newValues: obj}, () => {
      // Enable/disable submit button after state has been updated
      this.refreshSubmitButton()
    })
  }

  submitButtonClicked = (event) => {
    event.preventDefault()

    // Create add_single task
    this.createAddSingleTask(this.state.newValues)

    // Open friends page
    this.props.onPageSelected('friends')
  }

  createAddSingleTask = (properties) => {
    console.log('Creating add_single task with properties: ' + JSON.stringify(properties))

    // Initialize firebase tasks reference on-demand
    if (this.tasksRef === null) {
      this.tasksRef = firebase.database().ref().child('queue/tasks')
    }

    // Push a new add single task on the queue
    this.tasksRef.push({
      task: 'add_single',
      uid: this.props.uid,
      profile: properties
    })
  }
}

function FieldGroup ({id, label, help, ...props}) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/pages/AddSingle.js